/**
 * 解析完整文件名
 *
 * @param path            文件路径
 * @returns {string|null} 文件名
 */
export const parseFullFileName = (path) => {
	if (path == null) {
		return null;
	}
	const pos = path.lastIndexOf('/');
	let filename = '';
	if (pos !== -1) {
		filename = path.substring(pos + 1);
	}
	return filename;
};


// 根据省份证号码获取出生年月
export const getBirthdayFromIdCard = (idCard) => {
	var birthday = "";
	if (idCard != null && idCard != "") {
		if (idCard.length == 15) {
			birthday = "19" + idCard.substr(6, 6);
		} else if (idCard.length == 18) {
			birthday = idCard.substr(6, 8);
		}

		birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
	}

	return birthday;
};

// 获取当前格式化时间
export const getNowFormatDate = () => {
	var date = new Date();
	var seperator1 = "-";
	var seperator2 = ":";
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
		" " + date.getHours() + seperator2 + date.getMinutes() +
		seperator2 + date.getSeconds();
	return currentdate;
}


/**
 * @param strBirthday：指的是出生日期，格式为"1990-01-01"
 */
export const GetAge = (strBirthday, date = '') => {
	var returnAge,
		strBirthdayArr = strBirthday.split("-"),
		birthYear = strBirthdayArr[0],
		birthMonth = strBirthdayArr[1],
		birthDay = strBirthdayArr[2],
		d = new Date(date),
		nowYear = d.getFullYear(),
		nowMonth = d.getMonth() + 1,
		nowDay = d.getDate();
	if (nowYear == birthYear) {
		returnAge = 0; //同年 则为0周岁
	} else {
		var ageDiff = nowYear - birthYear; //年之差
		if (ageDiff > 0) {
			if (nowMonth == birthMonth) {
				var dayDiff = nowDay - birthDay; //日之差
				if (dayDiff < 0) {
					returnAge = ageDiff - 1;
				} else {
					returnAge = ageDiff;
				}
			} else {
				var monthDiff = nowMonth - birthMonth; //月之差
				if (monthDiff < 0) {
					returnAge = ageDiff - 1;
				} else {
					returnAge = ageDiff;
				}
			}
		} else {
			returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
		}
	}
	return returnAge; //返回周岁年龄
}
